
import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { MdKeyboardDoubleArrowRight } from 'react-icons/md';
import Skeleton from 'react-loading-skeleton'; 
import 'react-loading-skeleton/dist/skeleton.css';
import useCarCollection from '../CharterAdmin/libs/fetchcarCollection'; 
import './AllCharter.css';

const Carcharterservice = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;
    const { carData, isLoading, isError } = useCarCollection(currentPage);

    useEffect(() => {
        if (carData && carData.currentPage) {
            setCurrentPage(carData.currentPage);
        }
    }, [carData]);

    const handleScroll = useCallback(() => {
        if (
            window.innerHeight + document.documentElement.scrollTop === 
            document.documentElement.offsetHeight
        ) {
            if (currentPage < carData.totalPages) {
              
            }
        }
    }, [currentPage, carData]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [handleScroll]);

    if (isError) {
        return <div className='error'>No Car available now</div>;
    }

    if (isLoading) {
        return (
            <div className='vehicle-collection'>
                <span>
                    <Link to='/charteringservice'>Home</Link>
                    <MdKeyboardDoubleArrowRight />
                    <h3>Cars</h3>
                </span>
                <h3>CARS COLLECTION</h3>
                <div className="wrapper">
                    {[...Array(8)].map((_, index) => (
                        <div key={index} className="vehicle-list">
                            <Skeleton height={250} width={300} count={1} />
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    const { cars, totalCars } = carData; 

    if (!cars || cars.length === 0) {
        return <div>No cars available</div>; 
    }

    const handlePrevPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
      };
    
      const handleNextPage = () => {
        setCurrentPage((prevPage) => Math.min(prevPage + 1, carData.totalPages));
      };

    const totalPages = Math.ceil(totalCars / itemsPerPage);
    const startIndex = Math.min((currentPage - 1) * itemsPerPage + 1, totalCars);
    const endIndex = Math.min(startIndex + itemsPerPage - 1, totalCars);
  

    const clampWords = (text, maxWords) => {
        const words = text.split(' ');
        const clampedText = words.slice(0, maxWords).join(' ');
        return words.length > maxWords ? `${clampedText}...` : clampedText;
    };

    return (
        <div className='vehicle-collection'>
            <span>
                <Link to='/charteringservice'>Home</Link>
                <MdKeyboardDoubleArrowRight />
                <h3>Cars</h3>
            </span>
            <h3>CARS COLLECTION</h3>
            <div className="wrapper">
               {cars.map(car => (
                    <div key={car._id} className="vehicle-list">
                        <img src={car.images[0]} alt={car.vehicleModel} />
                        <h4>{car.vehicleModel}</h4>
                        <h3><p>Price Per Day:</p>{car.pricingPerDay
                      ? (car.pricingPerDay ).toLocaleString("en-US", {
                          style: "currency",
                          currency: "NGN",
                        })
                      : ""}</h3>
                        <p>{car.isHired ? 'Not available' : 'Available'}</p>
                        <p>{clampWords(car.description, 5)}<Link to={`/car-details/${car._id}`}>view details</Link></p>
                    </div>
                ))}
            </div>
            <div className="vehicle-collection-pagination">
                <span>{`Showing ${startIndex} - ${endIndex} of ${totalCars}`}</span>
                <div className="btn">
                    <button onClick={handlePrevPage} disabled={currentPage === 1}>
                        Prev
                    </button>
                    <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                        Next
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Carcharterservice;

